import { Utilisateur } from '../model/Utilisateur';

export const compare = (a, b) => {
    if (a.nom < b.nom) {
        return -1;
    }
    if (a.nom > b.nom) {
        return 1;
    }
    return 0;
};

// Get list of responsable + admin
export const responsablesFromUsers = (users: Utilisateur[]) => {
    return (
        users
            .filter((user) => user.role !== 'UTILISATEUR')
            //.map((user) => ({ id: user.id, value: user.id, label: `${user.nom} ${user.prenom}` }))
            .sort(compare)
    );
};
